// src/lib/registerAppShellSw.js
//
// Registra public/sw.js (cópia local do app para quedas da borda do Hosting).
// Fora de produção e em execuções sintéticas (Playwright, ?e2e=1, dev server)
// não registra: o cache-bust do index.html e os specs contam com rede pura.

const PRODUCTION_HOSTS = new Set([
  'consultamais.app',
  'www.consultamais.app',
  'consultamaissimplificada.web.app',
  'consultamaissimplificada.firebaseapp.com',
]);

function isSyntheticRun() {
  try {
    if (window.__E2E__ === true || window.__SKIP_CACHE_BUST__ === true) return true;
    if (typeof navigator !== 'undefined' && navigator.webdriver) return true;
    if (/\be2e=1\b/.test(window.location.search || '')) return true;
    const v = String(window.APP_VERSION || '');
    return !v || v.indexOf('{{') === 0 || v === 'e2e' || v.startsWith('test-');
  } catch {
    return true;
  }
}

export function registerAppShellSw() {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;
  if (!PRODUCTION_HOSTS.has(window.location.hostname)) return;
  if (isSyntheticRun()) return;

  const register = () => {
    navigator.serviceWorker
      .register('/sw.js', { scope: '/', updateViaCache: 'none' })
      .catch((err) => console.warn('[sw] registro falhou:', err && err.message));
  };

  if (document.readyState === 'complete') register();
  else window.addEventListener('load', register, { once: true });
}
